export default "__VITE_ASSET__CLy5DIlF__"